import * as React from 'react';
import { StepsContainerProps } from './StepsContainer.types';
import './styles/StepsContainer.css';

export const StepsContainer = ({
    children,
    className,
}: StepsContainerProps): JSX.Element => {
    return (
        <div className={`steps-container ${className}`}>
            {children}
        </div>
    )
}
    